<div class="side-menu-wrapper h-100 w-100 overflow-auto hide-scroll-bar d-flex flex-column justify-content-between" id="mySidenav"
  [ngClass]="{'collapsed': isCollapsed}">
 <img src="assets/images/icons/white-cross.svg" alt="" class="close-menu text-white d-xl-none position-absolute top-0 end-0 mt-3 me-3" (click)="closeNavMenu()" style="height: 30px;">
  <div>
    <div class="menu-logo-wrapper p-07 border-setting">
      <!-- Expanded header: wordmark on the left, collapse toggle on the right -->
      <div class="logo-full d-flex align-items-center justify-content-between">
        <img src="assets\images\icons\FM-logo.svg" alt="" class="menu-logo-img">
        <button type="button" class="sidebar-toggle d-none d-xl-flex align-items-center justify-content-center"
          (click)="toggleSidebar()" [attr.aria-label]="'Collapse menu'" [attr.title]="'Collapse menu'">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
            stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M15 18l-6-6 6-6" />
          </svg>
        </button>
      </div>
      <!-- Collapsed header: logo mark on top, expand toggle below it -->
      <div class="logo-collapsed d-none flex-column align-items-center">
        <img src="assets/images/icons/fm-white-icon.svg" alt="" class="menu-mark-img mb-2">
        <button type="button" class="sidebar-toggle d-none d-xl-flex align-items-center justify-content-center"
          (click)="toggleSidebar()" [attr.aria-label]="'Expand menu'" [attr.title]="'Expand menu'">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
            stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M9 18l6-6-6-6" />
          </svg>
        </button>
      </div>
    </div>
    <ul class="menu-list p-0 pt-3">
      @for (menu of visibleMenuList; track menu; let i = $index) {
        <li (click)="routeClick()"
          class="decoration-none mx-3 px-3 padding-menu cursor text-white radius-4"
          [attr.title]="isCollapsed ? menu.menu_name : null"
          [routerLink]="menu.submenu && menu.submenu.length ? null : menu.path"
          [ngClass]="{'active' : activeMenuStates[menu.path],'hideDispute' : menu.only_path == 0 && menu.menu_enum == 'DISPUTES' &&  (disputes_data <= 0 && _shared.dispute_count  == 0)}">
          <span class="menu-item-row d-flex w-100 justify-content-between" (click)="toggleMenu(menu)" >
            <span class="menu-item-main d-flex align-items-center">
              <img style="height: 20px; width: 20px;" [src]="'assets/images/menu-icons/' + menu.icon + '.png'" alt="" class="me-3">
              <p class="m-0 fs-14 fw-500 nav-label">
                {{ menu.menu_name }}
              </p>
            </span>
            @if (menu.menu_name ==='Disputes' && _shared.dispute_count > 0) {
              <span
                class="dispute-badge bg-light-primary hw-30 fs-16 rounded-pill  d-flex justify-content-center align-items-center text-white "
                ><span>{{_shared.dispute_count}}</span>
              </span>
            }
            @if (menu.submenu && menu.submenu.length) {
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" style="height: 16px;" class="toggle-arrow"
                [ngClass]="{ 'rotate': menu.isOpen }">
                <path
                  d="M201.4 374.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 306.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"
                  fill="#fff" />
              </svg>
            }
          </span>
          <ul class="sub-menu ps-2  overflow-hidden position-relative d-flex flex-column justify-content-between"
            [ngClass]="{'pt-3': menu.isOpen}"
            [ngStyle]="menu.isOpen ? {'height.px': 37 * menu.submenu.length} : {'height': '0px'}">
            @for (sub_menu of menu.submenu; track sub_menu; let i = $index) {
              @if (sub_menu.only_path == 0) {
                <li (click)="routeClick()" class="decoration-none  fs-14 text-white"
                  [routerLink]="sub_menu.path" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                  - {{ sub_menu.menu_name }}
                </li>
              }
            }
          </ul>
        </li>
      }
    </ul>
  </div>
  @if (_shared.hasFinanceCustomer) {
    <div class="p-3 radius-8 mx-3 mb-3 explore-box" >
      <h4 class="fs-14 fw-700 theme-text mb-2">
        {{environment.plans.secure.label}}
      </h4>
      <p class="fs-16 fw-800 mb-4">
        Enjoy lower interest rates for your customers, hassle-free payouts, and secured payments for you.
      </p>
      <div class="btn btn-primary w-100" [routerLink]="(userProfile.role_id !=5 || userProfile.role_id !='5'?  userProfile.is_approved != 1 && userProfile.is_approved != 2 : agentData?.is_approved !='1' && agentData?.is_approved !='2' ) ? null : '/app/finance/finance-customer'" [ngClass]="{'opacity-half': (userProfile.role_id !=5 || userProfile.role_id !='5'?  userProfile.is_approved != 1 && userProfile.is_approved != 2 : agentData?.is_approved !='1' && agentData?.is_approved !='2')}" [tooltip]="( userProfile.role_id !=5 || userProfile.role_id!='5'? userProfile.is_approved != 1 && userProfile.is_approved != 2 : agentData?.is_approved !='1' && agentData?.is_approved !='2') ? 'Your account has been disapproved. Please contact support for further assistance.' : ''">
        Start Now
      </div>
    </div>
  }
</div>
